import { IJsonQueryHighway } from '../../../packages/api-models/common/json_query';
import { getGeoValue, TGeoValue, TJsonQuery } from '../../../packages/JsonQuery';

export function setHighwaysInJsonQuery(jsonQuery: TJsonQuery, highwayIds: number[]): TGeoValue[] {
  const geo = getGeoValue()(jsonQuery);

  let value: TGeoValue[] = [];

  if (geo) {
    value = geo.filter(({ type }) => type !== 'highway');
  }

  return value.concat(highwayIds.map(id => ({ id, type: 'highway' }) as IJsonQueryHighway));
}
